import type { beeTypes } from '@beefree.io/sdk';

import type { IBeeFreeTokenAttributes } from '@feathr/blackbox';
import { TemplateClass } from '@feathr/blackbox';

export function getIsPage(type: TemplateClass): boolean {
  return [TemplateClass.Page, TemplateClass.ReferralPage, TemplateClass.LandingPage].includes(type);
}

export function createTokenObject(tokenResponse: IBeeFreeTokenAttributes): {
  access_token: string;
  v2: boolean;
  status: beeTypes.TokenStatus;
  shared: boolean;
  coediting_session_id: string | null;
} {
  const {
    access_token: accessToken,
    status,
    v2,
    shared,
    coediting_session_id: coeditingSessionId,
  } = tokenResponse;
  return {
    access_token: accessToken,
    status: status as beeTypes.TokenStatus,
    v2: v2,
    shared: shared,
    coediting_session_id: coeditingSessionId,
  };
}
